import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';

export const FormMicCharacteristic = ({
  characteristic,
  loading,
  handleInputChange,
  onSubmit,
  button,
}) => {
  return (
    <Form role="form" onSubmit={onSubmit}>
      <Row>
        <Col md="12" className='pt-2' >
          <FormGroup>
            <Label>
              Nombre del la caracteristica <span style={{ color: "#0079C7" }}>*</span>
            </Label>
            <Input
              type="text"
              name="characteristic"
              value={characteristic}
              onChange={handleInputChange}
              autoComplete="off"
              className="form-control form-control-sm input-air-primary"
            />
          </FormGroup>
        </Col>
      </Row>
      <ModalFooter>
        <Button
          size="sm"
          outline
          color="primary"
          type="submit" 
          disabled={loading}
          className={loading ? "progress-bar-animated progress-bar-striped" : ""}
        >
          {button}
        </Button>
      </ModalFooter>
    </Form>
  );
};
